<template>
  <div class="w-full text-left">
    <div class="bg-yell bord flex items-center justify-center h-99 text-white">
      <icon
        :data="icons.connect"
        height="60"
        width="60"
        class="mr-2 cursor-pointer"
        original
      />
      <div class="w-2/3">
        <div class="text-c14">
          Dernière connexion
        </div>
        <div class="mt-1 font-c8 text-c22 ">
          {{ dateConverter(flow.lastConnection) }}
        </div>
      </div>
    </div>

    <div class="bg-green-second bord flex mt-4 items-center justify-center h-99 text-white">
      <icon
        :data="icons.connect"
        height="60"
        width="60"
        class="mr-2 cursor-pointer"
        original
      />
      <div class="w-2/3">
        <div class="text-c14">
          Dernière sauvegarde
        </div>
        <div class="mt-1 font-c8 text-c22 ">
          {{ dateConverter(flow.lastSave) }}
        </div>
      </div>
    </div>


    <div class="w-full text-left bg-white bord mt-6">
      <div class="text-c16 font-c7 p-6">
        Informations sur l’entreprise
      </div>
      <div class="w-full h-0.5 bg-e5" />

      <div class="p-6">
        <div class="w-fulll bg-white flex  mb-4">
          <div class="text-c12 text-83 w-2/5">
            Nom:
          </div>

          <div class="w-3/5 text-c14">
            {{ flow.commerce.fullName }}
          </div>
        </div>

        <div class="w-fulll bg-white flex  mb-4">
          <div class="text-c12 text-83 w-2/5">
            Catégorie :
          </div>

          <div class="w-3/5 text-c14">
            {{ flow.commerce.categorie }}
          </div>
        </div>


        <div class="w-fulll bg-white flex  mb-4">
          <div class="text-c12 text-83 w-2/5">
            IFU :
          </div>

          <div class="w-3/5 text-c14">
            {{ flow.commerce.ifu }}
          </div>
        </div>

        <div class="w-fulll bg-white flex  mb-4">
          <div class="text-c12 text-83 w-2/5">
            Taille :
          </div>

          <div class="w-3/5 text-c14">
            {{ flow.commerce.taille }}
          </div>
        </div>

        <div class="w-fulll bg-white flex  mb-4">
          <div class="text-c12 text-83 w-2/5">
            Site internet :
          </div>

          <div class="w-3/5 text-c14">
            {{ flow.commerce.webSite }}
          </div>
        </div>

        <div class="w-fulll bg-white flex  mb-4">
          <div class="text-c12 text-83 w-2/5">
            Gérant :
          </div>

          <div class="w-3/5 text-c14">
            <span v-if="company">{{ company.body.firstName }} {{ company.body.lastName }}</span>
          </div>
        </div>

        <div class="w-fulll bg-white flex  mb-4">
          <div class="text-c12 text-83 w-2/5">
            Téléphone :
          </div>

          <div class="w-3/5 text-c14">
            <span v-if="company">{{ company.body.phone }}</span>
          </div>
        </div>

        <div class="w-fulll bg-white flex  mb-4">
          <div class="text-c12 text-83 w-2/5">
            SDF partenaires :
          </div>

          <div class="w-3/5 text-c14">
            {{ !flow.mySfd ? '- -': '' }}
            <div v-if="flow.mySfd">
              {{ flow.mySfd.length === 0 ? '- -': '' }}
              <div
                v-for="(item, index) in flow.mySfd"
                :key="index"
              >
                <div class="mb-1">
                  {{ item.body ? item.body.name : '--' }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="w-fulll bg-white flex  mb-4">
          <div class="text-c12 text-83 w-2/5">
            Date d’inscription :
          </div>

          <div class="w-3/5 text-c14">
            {{ dateConverter(flow.commerce.createdAt) }}
          </div>
        </div>

        <div class="w-fulll bg-white flex  mb-4">
          <div class="text-c12 text-83 w-2/5">
            Expert comptable :
          </div>

          <div class="w-3/5 text-c14">
            <div v-if="isLoadingAccountant" class="text-gray-500 text-sm">
              Chargement...
            </div>
            <div v-else-if="affectedAccountant" class="flex flex-col">
              <div class="font-medium">
                {{ getAccountantFullName(affectedAccountant) }}
              </div>
              <div v-if="affectedAccountant.email" class="text-gray-600 text-xs mt-1">
                {{ affectedAccountant.email }}
              </div>
              <div v-if="affectedAccountant.phone || affectedAccountant.phoneNumber" class="text-gray-600 text-xs mt-1">
                {{ affectedAccountant.phone || affectedAccountant.phoneNumber }}
              </div>
              <div v-if="affectedAccountant.office" class="text-gray-600 text-xs mt-1">
                Cabinet: {{ affectedAccountant.office }}
              </div>
            </div>
            <div v-else class="text-gray-500 text-sm">
              Aucun expert comptable affecté
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import connect from '../../../assets/icons/ic-last-connect.svg'
import save from '../../../assets/icons/ic-last-save.svg'
import { getAffected } from "@/component/cdevs/allFunctions";

export default {
  name: "Index",
props: {
  flow: {
    type: Object,
    default: null
  }
},
  data () {
    return {
      icons: {
        save,
        connect
      },
      company: null,
      affectedAccountant: null,
      isLoadingAccountant: false
    }
  },

  created () {
    this.company = this.$store.getters.trackCompany
    console.log('company data', this.company)
    // Récupérer l'expert comptable affecté
    this.getAffectedAccountant()
  },

  methods: {
    dateConverter (d) {
      return new Date(d).toLocaleString()
    },

    cleanObject(obj) {
      return Object.fromEntries(
        Object.entries(obj).filter(
          ([_, value]) => value !== null && value !== undefined && value !== ""
        )
      );
    },

    // Récupérer l'expert comptable affecté à l'entreprise
    async getAffectedAccountant() {
      // Utiliser this.company.id ou this.flow.commerce.id selon ce qui est disponible
      const companyId = this.company?.id || this.flow?.commerce?.id;
      
      if (!companyId) {
        console.warn('ID de l\'entreprise non disponible');
        return;
      }

      this.isLoadingAccountant = true;
      try {
        // L'API getAffected nécessite un userId (UUID du comptable), pas un companyId
        // On doit donc récupérer tous les comptables, puis leurs affectations
        
        // Étape 1: Récupérer tous les comptables
        const { getAccountant } = await import("@/component/cdevs/allFunctions");
        const accountantData = {
          apiKey: process.env.VUE_APP_OLD_X_PRIVATE_KEY,
          limit: 1000,
          page: 1,
          type: "CERTIFIED_ACCOUNTANT",
        };
        const cleanedAccountantData = this.cleanObject(accountantData);
        
        const accountantsResponse = await getAccountant(cleanedAccountantData);
        const accountantsList = accountantsResponse.data && Array.isArray(accountantsResponse.data) 
          ? accountantsResponse.data 
          : (accountantsResponse.data && accountantsResponse.data.items) || accountantsResponse.data || [];
        
        console.log(`${accountantsList.length} comptables trouvés, recherche de l'affectation...`);
        
        // Étape 2: Récupérer les affectations pour chaque comptable en parallèle (limité à 10 en même temps)
        const BATCH_SIZE = 10;
        let foundAccountant = null;
        
        for (let i = 0; i < accountantsList.length && !foundAccountant; i += BATCH_SIZE) {
          const batch = accountantsList.slice(i, i + BATCH_SIZE);
          
          // Récupérer les affectations en parallèle pour ce batch
          const affectationPromises = batch.map(async (accountant) => {
            if (!accountant.id) return null;
            
            try {
              const affectationData = {
                apiKey: process.env.VUE_APP_OLD_X_PRIVATE_KEY,
                limit: 1000,
                page: 1,
                userId: accountant.id, // UUID du comptable
              };
              const cleanedAffectationData = this.cleanObject(affectationData);
              
              const affectationResponse = await getAffected(cleanedAffectationData);
              const affectationsList = affectationResponse.data && Array.isArray(affectationResponse.data) 
                ? affectationResponse.data 
                : (affectationResponse.data && affectationResponse.data.items) || affectationResponse.data || [];
              
              // Chercher si cette entreprise est dans les affectations de ce comptable
              const foundAffectation = affectationsList.find(item => {
                const companyData = item.companyData || item.company;
                const itemCompanyId = companyData?.id || companyData?._id || item.companyId || item.company_id;
                return itemCompanyId && String(itemCompanyId) === String(companyId);
              });
              
              if (foundAffectation) {
                return accountant; // Retourner le comptable trouvé
              }
              return null;
            } catch (error) {
              // Continuer avec le comptable suivant en cas d'erreur
              console.warn(`Erreur pour le comptable ${accountant.id}:`, error);
              return null;
            }
          });
          
          // Attendre que toutes les requêtes du batch soient terminées
          const results = await Promise.all(affectationPromises);
          foundAccountant = results.find(result => result !== null);
          
          if (foundAccountant) {
            break; // Sortir de la boucle si on a trouvé
          }
        }
        
        if (foundAccountant) {
          this.affectedAccountant = foundAccountant;
          console.log('Expert comptable trouvé ▶', this.affectedAccountant);
        } else {
          console.log('Aucun expert comptable affecté trouvé pour cette entreprise');
        }
      } catch (error) {
        console.error('Erreur lors de la récupération de l\'expert comptable:', error);
        console.error('Détails de l\'erreur:', error.response?.data || error.message);
        // Ne pas afficher d'erreur toast car c'est une information optionnelle
      } finally {
        this.isLoadingAccountant = false;
      }
    },

    // Formater le nom complet du comptable
    getAccountantFullName(accountant) {
      if (!accountant) return '';
      return accountant.fullName || 
             `${accountant.firstName || ''} ${accountant.lastName || ''}`.trim() || 
             accountant.name || 
             'Non renseigné';
    }
  },
}
</script>

<style lang="scss" scoped>
img{
  object-fit: cover;
  width: 55px;
  height: 46px;
}
.bord {
  border-radius: 5.69577px;
}
</style>
